import React, { Component } from 'react'
import { connect } from 'react-redux';
import {Link, Switch} from 'react-router-dom'

import * as actionsCreators from  '../../store/actions/index';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
import axios from '../../http-config';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import Table from '@material-ui/core/Table';
import TablePagination from '@material-ui/core/TablePagination';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import moment from 'moment'
import MenuItem from '@material-ui/core/MenuItem';
import ScheduleDialog from './ScheduleDialog'
import Select from '@material-ui/core/Select';
import swal from 'sweetalert';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import NativeSelect from '@material-ui/core/NativeSelect';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Grid, Typography } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Menu from '@material-ui/core/Menu';
import Popper from '@material-ui/core/Popper';
import MenuList from '@material-ui/core/MenuList';
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import ReactPaginate from 'react-paginate';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import Fade from '@material-ui/core/Fade';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import clsx from 'clsx';
import { withTranslation } from 'react-i18next';

const ITEM_HEIGHT = 48;
const BootstrapInput = withStyles((theme) => ({
    root: {
      'label + &': {
        marginTop: theme.spacing(3),
      },
    },
    input: {
      borderRadius: 4,
      position: 'relative',
      backgroundColor:"#fff",
      border: '1px solid #4CAF50',
      fontSize: 15,
      padding: '7px 26px 7px 20px',
      transition: theme.transitions.create(['border-color']),
      // Use the system font instead of the default Roboto font.
      fontFamily: [
        'Open Sans',
        'sans-serif',
   
      ].join(','),
      '&:focus ': {
        borderRadius: 4,
            backgroundColor:"#fff !important"
   
      }
    },
  }))(InputBase);

  const useStyles = makeStyles({
    root: {
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
    icon: {
      borderRadius: '50%',
      width: 16,
      height: 16,
      boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
      backgroundColor: '#f5f8fa',
      backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
      '$root.Mui-focusVisible &': {
        outline: '2px auto rgba(19,124,189,.6)',
        outlineOffset: 2,
      },
      'input:hover ~ &': {
        backgroundColor: '#ebf1f5',
      },
      'input:disabled ~ &': {
        boxShadow: 'none',
        background: 'rgba(206,217,224,.5)',
      },
    },
    checkedIcon: {
      backgroundColor: '#3dab35',
      backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
      '&:before': {
        display: 'block',
        width: 16,
        height: 16,
        backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
        content: '""',
      },
      'input:hover ~ &': {
        backgroundColor: '#3dab35',
      },
    },
  });
  
  // Inspired by blueprintjs
  function StyledRadio(props) {
    const classes = useStyles();
  
    return (
      <Radio
        className={classes.root}
        disableRipple
        color="default"
        checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
        icon={<span className={classes.icon} />}
        {...props}
      />
    );
  }

class ScheduleProperty extends Component {
    
    state={ 
        open:false,
        openDialog:false,
        propertyId:'',
        filterBy:'-1',
        filterByType:"",
        propertyType : 'all',
        isAll:false,
        filterByWard:"",
        controls: {
            search: {
                value: '',
            }
        },
        activePage:0,
        limit:10,
        page:0,
        openFreq:false,
        FrequencyNum:'',
        anchorE:null,
        anchorEl:null,
        propUpdateFreqdaysErr:'',
        propertyIdFreq:'',
        sortOrder: '',
        currentSortId:'',
        isFilter:false,
        sortObj : {
            key: '',
            value: ''
        },
        EditDateTime:"",
        scheduleId:'',
        filterValue :'',
        editEmergency:'',
        LastDesludgedDate:'',
        WeekDay:this.props.configurableDay,
        dayChanged: false,
        id:'',
        freqStatus:'',
        selectEditOperatorName :'',
        freqDisableStatus : null,
        freqSelect:'custom',
        hideDaysField:false,
        message:'',
        selecedFreq : '',
        customFreqValue:'',
        page2ScheduleFilter : 1,

        propertyDate:'',
        propertyScheduleId:'',
        EmergencyData:'',
        ProPropUpdateFreqdays:'',
        lastDesludgeDate:'',
        collectStatus:'',
        filterValueStatus:'',
        requiredZone:localStorage.getItem('isZoneNotRequired'),
        summaryStatus:!!this.props&&this.props.match.params.id?this.props.match.params.id:'',
        summaryfromDate: moment(!!this.props&&this.props.history.location.fromDate).format('YYYY-MM-DD'),
        summarytoDate: moment(!!this.props&&this.props.history.location.toDate).format('YYYY-MM-DD'),
        summaryhistoryData : !!this.props&&this.props.location.url?this.props.location.url:'',
        openHistory:false,
        searchBy:'selectName',
        viewHistoryId:'',
        currentStatus: ''
           
    }
    componentDidMount() {
            let payload = {
                token: this.props.token,
                page:  this.state.page,
                limit: this.state.limit,
                sortName:this.state.sortObj.key,
                sortValue :this.state.sortObj.value,
                propertyTypeId: this.state.filterValue,
                zoneId: this.state.filterBy,
                wardId:this.state.filterByWard,
                searchQuery: this.state.controls.search.value,
                status: this.state.filterValueStatus,
                searchByFields : this.state.searchBy,
                viewHistory:this.state.viewHistoryId
            }
            let url = this.getUrl(this.state.propertyType)
            this.props.onFetchPropertyHeaders(payload);
            this.props.onFetchPropertyListing(payload,url,'schedule');
            this.props.onSchedulePropertyZone();
            this.props.onSchedulePropertyWard({zoneId:'-1',status: this.state.filterValueStatus })
            this.props.onPropertyType();
            this.props.onFetchOperatorDay(payload,url,'schedule');
           
        
       
    }

    openScheduleDialog = (propertyId,dateTime, scheduleId,editEmergencyData, operatorName) => {
        this.setState({
            propertyId:propertyId,
            EditDateTime:dateTime,
            scheduleId:scheduleId,
            editEmergency: editEmergencyData,
            selectEditOperatorName: operatorName
        },()=>{
            this.openTest()
        })
    }
    openTest = () =>{
        this.setState({
            openDialog:true
        })
    }

    handleDialogClose = (value) => {
        this.setState({
            openDialog:value
        }) 
    }
     handleClickFreqOpen = (propertyId,frequency,status, DesludgedDate) => {

      this.setState({ openFreq:true,propertyIdFreq:propertyId,FrequencyNum:frequency,customFreqValue:frequency, LastDesludgedDate:DesludgedDate,freqStatus: status}) ;
      
      };
    
       handleFreqClose = () => {
        this.setState({ openFreq:false}) ;
      };
    
    getUrl = (propertyType) => {
        let url = ''
        switch (propertyType) {
            case 'today':
                const date =  moment().add(0,'d').format('YYYY-MM-DD')
                 url =`/property/listProperties?scheduled_type=scheduled&toDate=${date}&fromDate=${moment(new Date()).format('YYYY-MM-DD')}&forScheduleProperty=true`
                break; 
            case '60 Days':
                const date60 =  moment().add(60,'d').format('YYYY-MM-DD')
                url =`/property/listProperties?scheduled_type=scheduled&toDate=${date60}&fromDate=${moment(new Date()).format('YYYY-MM-DD')}&forScheduleProperty=true`
                break;  
            case '90 Days':
                const date90 =  moment().add(90,'d').format('YYYY-MM-DD')
                url =`/property/listProperties?scheduled_type=scheduled&toDate=${date90}&fromDate=${moment(new Date()).format('YYYY-MM-DD')}&forScheduleProperty=true`
                break;   
            case '120 Days':
                const date120 =  moment().add(120,'d').format('YYYY-MM-DD')
                url =`/property/listProperties?scheduled_type=scheduled&toDate=${date120}&fromDate=${moment(new Date()).format('YYYY-MM-DD')}&forScheduleProperty=true`
                break;             
            default:
                url = `/property?forScheduleProperty=true`       
        }
        return url
    }

    handlePropertyType = (e) => {
        let url = ''
        this.setState({
            propertyType :e.target.value,
            activePage:0,
            page:0
        },() => {
            let payload = {
                token: this.props.token,
                page:  0,
                limit: this.state.limit,
                sortName:this.state.sortObj.key,
                sortValue :this.state.sortObj.value,
                propertyTypeId: this.state.filterValue,
                zoneId: this.state.filterBy,
                wardId:this.state.filterByWard,
                searchQuery: this.state.controls.search.value,
                status: this.state.filterValueStatus,
                searchByFields : this.state.searchBy,
                viewHistory:this.state.viewHistoryId
            }
            url = this.getUrl(this.state.propertyType)
            this.props.onFetchPropertyListing(payload,url,'schedule') 
        })
        this.setState({filterBy:''})
        this.setState({filterByWard:''})
    }

    inputChangedHadler = (event, controlName) => {
        const updatedControls = {
            ...this.state.controls,
            [controlName]: {
                ...this.state.controls[controlName],
                value: event.target.value,
            }
        }
        this.setState({ controls: updatedControls });
        if( updatedControls.search.value === ''){
            let payload = {
                token: this.props.token,
                searchQuery:'',
                limit:this.state.limit,
                page:  this.state.page,
                activePage:this.state.activePage,
                zoneId: this.state.filterBy,
                wardId:this.state.filterByWard,
                status: this.state.filterValueStatus,
                searchByFields : this.state.searchBy,
                viewHistory:this.state.viewHistoryId
            }
         let url = this.getUrl(this.state.propertyType)
            this.props.onSearchProperty(payload,url,'schedule') 
        }
        this.setState({filterBy:''})
        this.setState({filterByWard:''})
     
   
    }
    handleDayChange= (e) => {
        this.setState ({
            WeekDay: e.target.value,
            dayChanged:true
        },()=>
        this.onClickExport());
      };

    onClickExport=(e)=>{
        
        let payload = {           
            token: this.props.token,
            "configurableDay":this.state.WeekDay          
        }
        this.props.onAddDayData(payload);
    };

    refreshPage() {
        window.location.reload(false);
      };

    handlePropertySearch = (e) => {
        e.preventDefault()
        let searchVal = this.state.controls.search.value
        if (!!searchVal && searchVal.length >= 2) {
            let payload = {
                token: this.props.token,
                searchQuery:searchVal,
                limit:10,
                page:  this.state.page,
                activePage:this.state.activePage,
                zoneId: this.state.filterBy,
                wardId:this.state.filterByWard,
                status: this.state.filterValueStatus,
                searchByFields : this.state.searchBy,
                viewHistory:this.state.viewHistoryId
            }
            let url = this.getUrl(this.state.propertyType)
            this.props.onSearchProperty(payload,url,'schedule') 
        } else {
         
            swal("Enter atleast 2 characters")
        }
    }

    // handleChange = (e ) => {
    //     this.setState({filterBy:e.target.value})
    //     let payload = {
    //         zoneId:e.target.value,
    //         page:this.state.page,
    //         limit:this.state.limit,
    //         status: this.state.filterValueStatus,
    //         searchByFields : this.state.searchBy,
    //     }
    //     this.props.onSchedulePropertyWard(payload);
    //     this.props.onFilterZoneAndWard(payload);
      
    //     if(e.target.value === ""){
    //         this.state.filterByWard = ""
    //     }
    // }
    // handleChangeward =(e)=>{
    //     e.preventDefault();
    //     this.setState({filterByWard:e.target.value})
    //     let payload ={
    //         zoneId: this.state.filterBy,
    //         wardId:e.target.value,
    //         page:this.state.page,
    //         limit:this.state.limit,
    //         token: this.props.token,
    //         sortName:this.state.sortObj.key,
    //        sortValue :this.state.sortObj.value,
    //        propertyTypeId: this.state.filterValue,
    //        searchQuery: this.state.controls.search.value,
    //        status: this.state.filterValueStatus
    //     }
    //     this.props.onFilterZoneAndWard(payload);
    // }

    handleChangeFreq = (event) =>{
        this.setState({FrequencyNum:event.target.value},() => {
                if(!this.state.FrequencyNum){
                    this.setState({
                        propUpdateFreqdaysErr:'This field is required' 
                    })
                }else if(!this.state.FrequencyNum.match(/^[0-9]*$/)){
                    this.setState({
                        propUpdateFreqdaysErr:'Please enter valid number' 
                    })
                }else{
                    this.setState({
                        propUpdateFreqdaysErr:'' 
                    }) 
                }
        })
    }
    
    handleClickMoreVertIcon=(event,propertyId, propertyDate, propertyScheduleId,EmergencyData, ProPropUpdateFreqdays, lastDesludgeDate, collectStatus,currentStatus)=>{

        this.setState({open:!this.state.open,anchorEl:event.currentTarget,propertyId : propertyId, propertyDate:propertyDate, propertyScheduleId:propertyScheduleId, EmergencyData, ProPropUpdateFreqdays, lastDesludgeDate, collectStatus,currentStatus})
      }
    handleFreqSubmit =(e)=>{
        e.preventDefault()
        let payload={
            token: this.props.token,
            propertyId:this.state.propertyIdFreq,
            propUpdateFreqdays:this.state.FrequencyNum,
            propertyTypeId: this.state.filterValue,
            sortName:this.state.sortObj.key,
            sortValue :this.state.sortObj.value,
            zoneId: this.state.filterBy,
            wardId:this.state.filterByWard,
            selecedFreq : this.state.selecedFreq,
            viewHistory:this.state.viewHistoryId
        }
        if(!this.state.FrequencyNum){
            this.setState({
                propUpdateFreqdaysErr:'This field is required' 
            })
        }
        if(this.state.propUpdateFreqdaysErr == '' && this.state.FrequencyNum){
            this.props.onAddFreqSchedule(payload)
            this.setState({ openFreq:false,FrequencyNum:'',propUpdateFreqdaysErr:'',activePage:this.state.activePage,freqDisableStatus:false}) 
            let payload1 = {
                token: this.props.token,
            }
        }
        
    }

    handleClickAwayEditPopUp = () => {
        this.setState({open:false});
        };
        handleClickAwayEdit = () => {
            this.setState({open:false});
        };
    handlePageClick = (e) => {
       
            this.setState({
                page:e.selected + 1,
                activePage : e.selected
            },() => {
                let payload = {
                    token: this.props.token,
                    sortName:this.state.sortObj.key,
                   sortValue :this.state.sortObj.value,
                   propertyTypeId: this.state.filterValue,
                   zoneId: this.state.filterBy,
                   limit:this.state.limit,
                   page:e.selected + 1,
                   wardId:this.state.filterByWard,
                   searchQuery: this.state.controls.search.value,
                   status: this.state.filterValueStatus,
                   searchByFields : this.state.searchBy,
                   viewHistory:this.state.viewHistoryId
                }
                let url = this.getUrl(this.state.propertyType)
                this.props.onFetchPropertyListing(payload,url,'schedule') 
                this.props.onfetchPropertyHisorty(payload)
            }) 
        

          
        
    
    };   
    handleSort = (e,sortBy) => {
               let sortObj
               if (this.state.sortObj.key === sortBy.accessor) {
                   let value = (this.state.sortObj.value === 'DESC') ? 'ASC' : 'DESC';
                   sortObj = {
                       key : sortBy.accessor,
                       value: value
                   }
               } 
               else {
                   sortObj = {
                       key : sortBy.accessor,
                       value: 'DESC'
                }    
                }
        
               this.setState({ sortObj: sortObj ,currentSortId:sortBy.accessor});
          
               let payload = {
                   token: this.props.token,
                   sortName:sortObj.key,
                sortValue : sortObj.value,
                propertyTypeId: this.state.filterValue,
                zoneId: this.state.filterBy,
                limit:this.state.limit,
                activePage:this.state.activePage,
                page: this.state.page,
                wardId:this.state.filterByWard,
                status: this.state.filterValueStatus,
                searchByFields : this.state.searchBy,
                viewHistory:this.state.viewHistoryId
               }
           let url = this.getUrl(this.state.propertyType)
       this.props.onFetchPropertyListing(payload,url,'schedule');
            
         
             }

        onClickGetFilterVals = (e, colObj) => {
                let payload = {
                    token: this.props.token,
                    page:  this.state.page,
                    limit: this.state.limit,
                    sortName:this.state.sortObj.key,
                    sortValue :this.state.sortObj.value,
                    activePage:this.state.activePage,
                    propertyTypeId: e,
                    zoneId: this.state.filterBy,
                    wardId:this.state.filterByWard,
                    status: this.state.filterValueStatus,
                    searchByFields : this.state.searchBy,
                    viewHistory:this.state.viewHistoryId
                }
                this.setState({filterValue: e})
                let url = this.getUrl(this.state.propertyType)
                this.props.onFetchPropertyListing(payload,url,'schedule');
            
     

        }   
        // handleDelete =(id)=>{
        //     let payload = {
        //         scheduleId: id,
        //         propertyTypeId: this.state.filterValue,
        //         token: this.props.token,
        //         page:  this.state.page,
        //         activePage:this.state.activePage,
        //         limit: this.state.limit,
        //         sortName:this.state.sortObj.key,
        //         sortValue :this.state.sortObj.value,
        //         zoneId: this.state.filterBy,
        //         wardId:this.state.filterByWard
        //     }
        //     this.props.onDeleteScheduleProperty(payload)

        // }  


        handleChangefreqSelect = (e)=>{
            if(e.target.value === 'custom'){
                this.setState({freqDisableStatus: false, selecedFreq:e.target.value, FrequencyNum: this.state.customFreqValue})
            }
            if(e.target.value === 'daily'){

                this.setState({ freqDisableStatus: true, selecedFreq:e.target.value, FrequencyNum:1})
            }
            if(e.target.value === 'alternate'){
            this.setState({freqDisableStatus: true, selecedFreq:e.target.value, FrequencyNum:2})
            }
        
        }

        handleZoneChange=(e)=>{
            this.setState({requiredZone: e.target.value},()=>{
                let payload = {
                    token: this.props.token,
                    "isZoneNotRequired": this.state.requiredZone
                }
                this.props.oNisZoneRequired(payload)
            })

        }

        onClickGetFilterValsStatus=(e )=>{
            this.setState({filterValueStatus: e})
            let payload = {
                token: this.props.token,
                page:  this.state.page,
                limit: this.state.limit,
                sortName:this.state.sortObj.key,
                sortValue :this.state.sortObj.value,
                propertyTypeId: this.state.filterValue,
                zoneId: this.state.filterBy,
                wardId:this.state.filterByWard,
                searchQuery: this.state.controls.search.value,
                status: e,
                searchByFields : this.state.searchBy,
                viewHistory:this.state.viewHistoryId
            }
            let url = this.getUrl(this.state.propertyType)
            this.props.onFetchPropertyListing(payload,url,'schedule');
        // }
        }

        handleOpenPopHistory =(propId)=>{
            this.setState({openHistory:true, viewHistoryId: propId})
            if(propId){
                let payload = {
                    token: this.props.token,
                    page:  this.state.page,
                    limit: this.state.limit,
                    sortName:this.state.sortObj.key,
                    sortValue :this.state.sortObj.value,
                    propertyTypeId: this.state.filterValue,
                    // zoneId: this.state.filterBy,
                    // wardId:this.state.filterByWard,
                    // searchQuery: this.state.controls.search.value,
                    status: this.state.filterValueStatus,
                    // searchByFields : this.state.searchBy,
                    viewHistory:propId
                }
                this.props.onfetchPropertyHisorty(payload)
            }
           
        }
        handleClosePopHistory =()=>{
            this.setState({openHistory:false, page:0, activePage:0})
            
            let payload = {
                token: this.props.token,
                page:  0,
                limit: this.state.limit,
                sortName:this.state.sortObj.key,
                sortValue :this.state.sortObj.value,
                propertyTypeId: this.state.filterValue,
                // zoneId: this.state.filterBy,
                // wardId:this.state.filterByWard,
                // searchQuery: this.state.controls.search.value,
                status: this.state.filterValueStatus,
                // searchByFields : this.state.searchBy,
                viewHistory:this.state.viewHistoryId
            }
            this.props.onfetchPropertyHisorty(payload)
        }

        handleChangeSearch=(e)=>{
            if(e.target.value == 'selectName'){
                let payload = {
                    token: this.props.token,
                    page:  this.state.page,
                    limit: this.state.limit,
                    sortName:this.state.sortObj.key,
                    sortValue :this.state.sortObj.value,
                    propertyTypeId: this.state.filterValue,
                    zoneId: this.state.filterBy,
                    wardId:this.state.filterByWard,
                    searchQuery: this.state.controls.search.value,
                    status: this.state.filterValueStatus,
                    viewHistory:this.state.viewHistoryId
                    
                }
                // this.props.onFetchPropertyListing(payload)
                let url = this.getUrl(this.state.propertyType)
                this.props.onFetchPropertyListing(payload,url,'schedule');
            }
            this.setState({searchBy:e.target.value, searchByFields:e.target.name })
        }
        handleChangePage = (event, newPage) => {
            // setPage(newPage);
            this.setState({page:newPage})
          };
          handleChangeRowsPerPage = (event) => {
            this.setState({limit:parseInt(event.target.value, 10),page:0});
            
          };
    render() {
        const {t, i18n} = this.props
        let filterValue;
        let filterValueStatus;
        let data = Array.from(this.props.operatorDay);
        // let updatedHeaders =!!this.props.headers&& this.props.headers.filter( (header) => {
        //     if(header.accessor == 'propertyType'){
        //         header.header = 'Property Type'
        //         header.filter = true
        //     }

        //     return (header.accessor == "id" ||header.accessor == "name" || header.accessor == 'zone' || header.accessor == 'ward' || header.accessor === 'ulb' || header.accessor === 'propertyType')
        // })

    const updatedHeaders=[
            {
                header:"Sr no.",
                accessor :"id",
                sortable:"false",
                filter:"false"
            },
            {
                header:"Request Id",
                accessor:"ReqId",
                sortable:"false",
                filter:"false"
            },
            {
                header:"House No.",
                accessor :"ownerDoorNo",
                sortable:"false",
                filter:"false"
            },
            {
                header:"Tax Assessment No.",
                accessor :"assessment_no",
                sortable:"false",
                filter:"false"
            },
            {
                accessor: "zone",
                filter: "false",
                header: "Zone",
                sortable: "false"
            },
            {
            accessor: "ward",
            filter: "false",
            header: "Ward",
            sortable: "false"
            },
            {
                accessor: "locality",
                filter: "false",
                header: "Locality",
                sortable: "false"
                },

            {
                accessor: "usagesType",
                filter: "false",
                header: "Usage",
                sortable: "false"
                },
            {
                header     : "Pincode",
                accessor  : "pinCode",
                sortable   : "false",
                filter     : "false"
            },
            
            {
                header:"Owner/Citizen Name",
                accessor:"ownerName",
                sortable:"false",
                filter:"false"
            },

            {
                accessor: "name",
                filter: "false",
                header: "Property Building Name/Address",
                sortable: "true"
            },
         
            {
                accessor: "propertyType",
                filter: "false",
                header: "Property Type",
                sortable: "false"
            },
            {
                accessor: "ulb",
                filter: "false",
                header: "ULB Name",
                sortable: "false"
            },
            {
                header:"Scheduled Date",
                accessor:"dateTime",
                sortable:"false",
                filter:"false"
            },
            {
                accessor: "operatorName",
                filter: "false",
                header: "Operator Name",
                sortable: "false"
            },

            {
                accessor: "truckNo",
                filter: "false",
                header: "Truck No",
                sortable: "false"
            },
            {
                accessor: "upcomingColletionDate",
                filter: "false",
                header: "Visit Date",
                sortable: "false"
            },
            {
                accessor: "visitTime",
                filter: "false",
                header: "Visit Time",
                sortable: "false"
            },
        

        {
            header:"Service status",
            accessor:"status",
            sortable:"false",
            filter:"true"
        },
        {
            header: "Schedule Frequency in days", 
            accessor: "propUpdateFreqdays", 
            sortable: "false", 
            filter: "true"
        },
      
        {
            header: "Action", 
            accessor: "actionButton", 
            sortable: "false", 
            filter: "true"
        }]

const historyHeaders = [
    {
        accessor: "operatorName",
        filter: "false",
        header: "Operator Name",
        sortable: "false",
    },
    {
        accessor: "truckNo",
        filter: "false",
        header: "Truck No",
        sortable: "false",
    },
    {
        accessor: "tfName",
        filter: "false",
        header: "TF No",
        sortable: "false",
    },
    {
        accessor: "GPSLocation",
        filter: "false",
        header: "GPS Location",
        sortable: "false",
    },  
    {
        accessor: "scheduledDate",
        filter: "false",
        header: "Scheduled Date",
        sortable: "false",
    },  
    {
        accessor: "collectionDate",
        filter: "false",
        header: "Collected Date",
        sortable: "false",
    },
    {
        accessor:"disposedDate",
        filter: "false",
        header: "Disposed Date",
        sortable: "false",
    },
    { header: "Refused Date", 
    accessor: "refusedDate",  
    filter: "false", 
    sortable: "false"
    },
    { 
        header: "Cancelled Date", 
        accessor: "cancelledDate", 
        filter: "false", 
        sortable: "false"
        },
        { header: "Expired Date", 
        accessor: "expiredDate", 
        filter: "false",
        sortable: "false"
        },
]

const headerHistoryPopup = historyHeaders.map((header)=>{
    return (
        <TableCell align='center'  key={header.header} className={"white-space"}>
                             <div style={{
                                    display: 'flex',
                                    textAlign: "center",
                                    whiteSpace: 'break-spaces',
                                    height:'3em',
                                    // flexDirection:'column !important'
                                    // marginLeft:'135px'
                                    }}>
                                {header.header}
                            </div>
                        </TableCell>
    )
})
        const headers = !!updatedHeaders&& updatedHeaders.map(header => {
            if(header.accessor == "status"){
                // header.header = 'Status'
                header.filter = false
            }  
            if(header.accessor == "propertyType"){
                // header.header = 'Status'
                header.filter = true
            } 

            let filterType
            let StatusType
            if(header.filter == true&&header.accessor == "propertyType"){
                filterType = 
                <select 
                style={{
                    width: '16px',
                    borderColor:"white",
                    backgroundColor: 'LightGray',
                    outline:"none",
                    display: "flex",
                    alignItems: 'right',   
                  }}
                value={filterValue}
                onChange={(e) => {
                    this.onClickGetFilterVals(e.target.value , header)
                }}
                >
                    <option value="">All</option>
                    {!!this.props.propertyTypeList&&this.props.propertyTypeList.map((option, i) => {

                   return (   <option key={i} value={option.Id}>
                            {option.Name}
                        </option>)
                         })}
                </select>
            }

            if(header.filter == true &&header.accessor == "status" ){
                StatusType = 
            <select 
            style={{
                width: '16px',
                borderColor:"white",
                backgroundColor: 'LightGray',
                outline:"none",
                display: "flex",
                alignItems: 'right',   
              }}
            value={filterValueStatus}
            onChange={(e) => {
                this.onClickGetFilterValsStatus(e.target.value, header)
            }}
            >           <option value="">All</option>
                       <option value="scheduled">Scheduled</option>
                       <option value="collected">Collected</option>
                       <option value="expired">Expired</option>
                       <option value="refused">Refused</option>
                       <option value="cancelled">Cancelled</option>
                       <option value="disposed">Disposed</option>
                </select>
         
            }

          {
                return  (<TableCell key={header.header} className={"white-space"}>
                            
                             <div style={header.accessor == "taxAssessmentNo"||header.accessor == "name" || header.accessor == "ownerName" || header.accessor == "propUpdateFreqdays"?{
                                    display: 'flex',
                                    alignItems: 'start',
                                    width:'220px',
                                    whiteSpace: 'break-spaces',
                                    height:'3em',
                                        }: {
                                    display: 'flex',
                                    alignItems: 'start',
                                    width:'120px',
                                    whiteSpace: 'break-spaces',
                                    height:'3em',
                                        }}>
                          {filterType}
                        {header.header}
                        <div onClick={(e) =>  this.handleSort(e,header)}>
                            
                            {header.header == "Property Type" || header.accessor =="status" ?'':    <div>{
                             this.state.currentSortId===header.accessor? this.state.sortObj.value ==='ASC'?(<ArrowDropDownIcon fontSize="small"/>):(<ArrowDropUpIcon fontSize="small"/>) :(<ArrowDropDownIcon fontSize="small"/>)
                           }
                           </div> }
                          
                       </div>
                       
          
                                {/* {header.header} */}
                                {/* {!!this.state.summaryStatus&&this.state.summaryStatus === 'refused' ||!!this.state.summaryStatus&&this.state.summaryStatus === 'expired'||!!this.state.summaryStatus&&this.state.summaryStatus === 'cancelled'? "": StatusType}  */}
                                {/* {StatusType} */}
                                
                            </div>
                        </TableCell>)
            }
        }
        );
        const propertyHistory = !!this.props.propertyHistory&&this.props.propertyHistory.map((data, i)=>{
            return <TableRow style={{whiteSpace: 'normal',
            wordWrap: 'break-word'}} key={i}>
                {
                    !!historyHeaders&&historyHeaders.map((header,t)=>{
                        return  <TableCell style={{
                            whiteSpace: "normal",
                            wordWrap: "break-word"
                        }} key={i} className={"white-space"}>{data[header.accessor] == null || data[header.accessor] == 'null' ? ' ' : data[header.accessor]}</TableCell>
                    })
                }
         </TableRow>
        })
        
        const properties=!!this.props.propertyListing&&this.props.propertyListing.slice(this.state.page * this.state.limit, (this.state.page * this.state.limit )+ this.state.limit).map((property, j) =>   {
        const propertyId=property["propertyId"]
        const propertyDate = property["dateTime"]
        const propertyScheduleId = property["scheduleId"]
        const EmergencyData = property['emergency']
        const propstatus = property['status']
        const currentStatus = property['currentStatus']
        const lastDesludgeDate= property["lastDesludgeDate"]
            return <TableRow style={{whiteSpace: 'normal',
            wordWrap: 'break-word'}} key={j}>{
                !!updatedHeaders&&updatedHeaders.map((header, i)=>{
                       if(header.accessor=='actionButton'){
                        return <TableCell key={i} >
                                        <IconButton
                                            aria-label="more"
                                            aria-controls="long-menu"
                                            aria-haspopup="true"
                                            onClick={(e)=>this.handleClickMoreVertIcon(e,propertyId, propertyDate, propertyScheduleId,EmergencyData, property.propUpdateFreqdays,lastDesludgeDate, propstatus, currentStatus)}
                                            >
                                            <MoreVertIcon fontSize='small'/>
                                            </IconButton>
                                                <Popper
                                                open={this.state.open} anchorEl={this.state.anchorEl}>
                                                 <ClickAwayListener onClickAway={this.handleClickAwayEdit}>
                                                <Paper style={{boxShadow:"none", border:"1px solid #3dab35"}}>
                                                    <MenuList>
                                                    
                                                    {this.state.propertyDate !== null&& this.state.currentStatus== 'scheduled'?
                                                      <MenuItem onClick={() => this.openScheduleDialog(this.state.propertyId, this.state.propertyDate, this.state.propertyScheduleId,this.state.EmergencyData )}>{t("editSchedule")}</MenuItem>
                                                 : this.state.propertyDate !== null && this.state.currentStatus == 'disposed' ?
                                                      <MenuItem onClick={() => this.openScheduleDialog(this.state.propertyId)}>{t("repSchedule")}</MenuItem>     
                                                 :    <MenuItem  onClick={() => this.openScheduleDialog(this.state.propertyId)}>{t("addSchedule")}</MenuItem>
                                                }
                                            
                                                     <MenuItem  onClick={() => this.handleClickFreqOpen(this.state.propertyId,this.state.ProPropUpdateFreqdays,this.state.collectStatus, this.state.lastDesludgeDate)}>{t("setFreq")}</MenuItem>
                                                        <MenuItem  onClick={()=>this.handleOpenPopHistory(this.state.propertyId)}>{t("viewHist")}</MenuItem> 
                                                     {/* {
                                                         this.state.collectStatus== 'Scheduled'? 
                                                         <MenuItem  onClick = { () => {
                                                            swal({ title   : "Are you sure?",
                                                                text    : "Once deleted, you will not be able to recover this data!",
                                                                icon    : "warning",
                                                                buttons : {
                                                                cancel  : 'No',
                                                                confirm : 'Yes'}
                                                            })
                                                            .then((willDelete) => {
                                                                if (willDelete) {
                                                                    this.handleDelete(this.state.propertyScheduleId) 
                                                                } 
                                                            });
                                                        }}>Delete</MenuItem>:''
                                                     }
                                                     */}
                                                    </MenuList>
                                                </Paper>
                                                </ClickAwayListener>
                                            </Popper>
                           
                        </TableCell>
                       }
                       else if(header.accessor=='updatedAt'){
                           return <TableCell style={{
                            whiteSpace: "normal",
                            wordWrap: "break-word"
                          }} key={i} >{ moment(property[header.accessor]).format('DD-MMM-YYYY hh:mm a')}</TableCell>
                       }
                       else if(header.accessor == 'name' ){
                         if(property['ctptName'] != null ){
                            return <TableCell>{property['ctptName'] }</TableCell>
                        }
                        else{
                            return <TableCell>{property[header.accessor] ? property[header.accessor] :   property['propertyName']  }</TableCell>
                        }
                          
                       }
                   
                       else if(header.accessor == 'operatorName'){
                        return <TableCell>{property[header.accessor] ? property[header.accessor] : property['operatorName'] }</TableCell>
                    }

                       else if(header.accessor=='lastDesludgeDate'){
                        return <TableCell  style={{
                         whiteSpace: "normal",
                         wordWrap: "break-word"
                       }} key={i}>{ property[header.accessor] && moment(property[header.accessor]).format('DD-MMM-YYYY')}</TableCell>
                    }
                    else if(header.accessor == 'dateTime' ){
                            return <TableCell  style={{
                                whiteSpace: "normal",
                                wordWrap: "break-word"
                            }} key={i}>{ property[header.accessor ] ? moment(property[header.accessor]).format('DD-MMM-YYYY') :property['scheduledDate']? property['scheduledDate']: '-'}</TableCell>
                    
                       
                    }
                    else if(header.accessor === 'ScheduleFrequencyButton'){
                            return <TableCell>
                                <Button style={{border:'1px solid #4CAF50',color: '#4CAF50',textAlign: 'center',height:'35px',textTransform:'capitalize'}} type="submit" 
                                    onClick={() => this.handleClickFreqOpen(propertyId)}>
                                        {t("setFreq")}</Button>
                            </TableCell>
                    }

                    else if(header.accessor == 'collectedDate'){
                     
                        return <TableCell  style={{
                            whiteSpace: "normal",
                            wordWrap: "break-word"
                          }} key={i}>{ property[header.accessor ] ? moment(property[header.accessor]).format('DD-MMM-YYYY') : '-'}</TableCell>
                    }
                    else if(header.accessor === 'propUpdateFreqdays'){
                        return<TableCell tyle={{
                            whiteSpace: "normal",
                            wordWrap: "break-word"
                          }} key={i}>
                            { !!property.propUpdateFreqdays&&property.propUpdateFreqdays ?property.propUpdateFreqdays : '-'  }
                        </TableCell>
                    }
                    else if(header.accessor == "id"){
                        if(property['sr.no'] != null ){
                            return <TableCell>{property['sr.no'] }</TableCell>
                        }
                        else{
                            return <TableCell>{property[header.accessor] ? property[header.accessor] :   property['id']  }</TableCell>
                        }
                    }
                    else if(header.accessor == "visitTime"){
                            return <TableCell style={{
                                whiteSpace: "normal",
                                wordWrap: "break-word"
                              }} >{property['UpcomingColletionStartTime'] == null &&property['UpcomingColletionEndTime'] == null? "-": property['UpcomingColletionStartTime'] + " - "+ property['UpcomingColletionEndTime']}</TableCell>
                        
                    }
                    else if(header.accessor === "upcomingColletionDate"){
                        return <TableCell  style={{
                            whiteSpace: "normal",
                            wordWrap: "break-word"
                          }} key={i}>{ property[header.accessor ] ? moment(property[header.accessor]).format('DD-MMM-YYYY') : '-'}</TableCell>
                    }
                    else{
                           return  <TableCell style={{
                            whiteSpace: "normal",
                            wordWrap: "break-word"
                          }} key={i} className={"white-space"}>{property[header.accessor] == null || property[header.accessor] == 'null' ? ' ' : property[header.accessor]}</TableCell>
                    }
                 
                }) 
            }
            </TableRow>

    })
 
        return (
            <div>
                <div className="dashboard_right_content">
                    <img className="dashboard_right_content_top_icon" src="images/Rectangle.svg" />
                        <div className="dashboard_right_content_top">
                            {/* <h5> <Link to ={!!this.state.summaryhistoryData&&this.state.summaryhistoryData != ''? {pathname:'/property-History/allHisorty', fromREC:!! this.props.location&&this.props.location.fromDate, toDateREC:!! this.props.location&&this.props.location.toDate }:{pathname:"/schedule-property/allData", fromF: !! this.props.location&&this.props.location.fromDate, todateF:!!this.props.location&& this.props.location.toDate}}  className="email_link"><ArrowBackIosIcon></ArrowBackIosIcon></Link>{!!this.props&&this.props.match.params.id == 'refused'? 'Refused Properties': !!this.props&&this.props.match.params.id == 'expired'? 'Expired Properties': !!this.props&&this.props.match.params.id == 'cancelled'? 'Cancelled Properties': ' Schedule Properties' }</h5> */}
                            <h5>{t("scheduledPropH")}</h5>
                         
                            <div className="dashboard_right_content_top_options">
                            <div>
                        <FormControl>
                            <Select value={this.state.searchBy}
                                onChange={this.handleChangeSearch}
                                name="searchBy"
                                style={{ width: '100%' , border:"1px solid #ccc", borderRadius:'5px'}}>
                                 <MenuItem value={"selectName"}>{t("selectName")}</MenuItem>
                                    <MenuItem value={"propertyName"}>{t("byPropName")}</MenuItem>
                                    <MenuItem value={"propertyTyp"}>{t("byPropType")}</MenuItem>
                                    <MenuItem value={"request"}>{t("byReqId")}</MenuItem>
                                
                            </Select>
                             </FormControl>
                      </div>

                            <div className="dashboard_right_content_top_search">
                                <Paper component="form">
                                    <IconButton aria-label="menu">
                                        <img src="images/search_icon.svg" />
                                    </IconButton>
                                    <InputBase onChange={(event) => this.inputChangedHadler(event, 'search')} placeholder={this.state.searchBy == "selectName"? "": this.state.searchBy=="propertyName"? t("propName"): this.state.searchBy=="propertyTyp"? t("propType"): this.state.searchBy=="request"?t("reqId"):  ""} />
                                    <Button onClick={this.handlePropertySearch} variant="contained" color="primary" type="submit">{t("search")}</Button>
                                </Paper>
                            </div>

                        </div>
                        </div>
                    </div>
                    <div> 
                    {(this.props.loadingData ==false) ? <div id="cover-spin"></div>:''}
                    
                    <div className="operator_listing" >
                        
                   
                        <TableContainer component={Paper} style={{paddingLeft:"15px",paddingRight:"15px"}}>
                             <Table aria-label="sticky table">
                                <TableHead >
                                    <TableRow >
                                        {headers}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                        {!!this.props.propertyListing&&this.props.propertyListing.length=== 0 && this.props.loadingData ==true? <TableRow style={{alignItems:'center', fontWeight:'bold', color:'gray' }}>
                                            Loading....</TableRow>: !!this.props.propertyListing&&this.props.propertyListing.length== 0? <TableRow style={{alignItems:'center', fontWeight:'bold', color:'gray' }}>
                                            No Records Found !!</TableRow>: this.props.loadingData ==false ?<TableRow style={{alignItems:'center', fontWeight:'bold', color:'gray' }}>
                                            Loading....</TableRow> : properties}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        
                    </div>
                    </div>
                    {
                this.props.totalCount && this.props.totalCount != 0 && 
                    <TablePagination
                    rowsPerPageOptions={[10,50,100]}
                    colSpan={3}
                    count={this.props.totalCount}
                    component="div"
                    rowsPerPage={this.state.limit}
                    page={this.state.page}
                    SelectProps={{
                    inputProps: { 'aria-label': 'rows per page' },
                    native: true,
                    }}
                    labelRowsPerPage={t("rowsPerPage")}
                    containerClassName={"pagination"}
                    subContainerClassName={"pages pagination"}
                    onChangePage={this.handleChangePage}
                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                />
                }
                    <ScheduleDialog selectEditOperatorName={this.state.selectEditOperatorName} editEmergency={this.state.editEmergency} propertyTypeId={this.state.filterValue} dataEdit={this.state.EditDateTime} scheduleIdEdit={this.state.scheduleId} pageSchedule={this.state.page}
                     activeSchedule={this.state.activePage} SORT={this.state.sortObj} open={this.state.openDialog} uRl= { this.getUrl(this.state.propertyType)} urlPropertyType={this.state.propertyType} handleClose = {this.handleDialogClose} propertyId = {this.state.propertyId} summaryStatus={this.state.summaryStatus}  fromDateSumm={this.state.summaryfromDate}
                     toDateSumm={this.state.summarytoDate} setFreqPop={this.state.ProPropUpdateFreqdays}></ScheduleDialog>
      <div className="setFreq">
      <Dialog
        maxWidth={'xs'}
        fullWidth={true} 
        // open={true}
        open={this.state.openFreq}
        aria-labelledby="responsive-dialog-title">
        <DialogTitle className="text-center border-none " style={{color:'#3dab35'}}><span style={{fontSize:'18px'}}>{t("scheduledFreq")}</span></DialogTitle>
        <DialogContent > 
            <div className="create_ulb_content_outer">
                <div className="create_ulb_content_sched">
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                        <FormControl component="fieldset" className="login_options">
                        <RadioGroup defaultValue={this.state.freqSelect} aria-label="freqSelect" name="freqSelect" onChange ={(e)=>this.handleChangefreqSelect(e)}>
                         <FormControlLabel value="daily" control={<StyledRadio />} label={t("daily")} />
                                <FormControlLabel value="alternate" control={<StyledRadio />} label={t("alternate")} />
                                <FormControlLabel value="custom" control={<StyledRadio />} label={t("custom")} />
                                </RadioGroup>
                        </FormControl>
                        </Grid>

                        <Grid item xs={12}>
                            <FormControl>
                                <label className="required" style={{fontWeight:'bold'}} htmlFor="FrequencyNo" >{t("days")}</label>
                                <TextField id="areaName"  
                                    name="areaName"
                                    variant = "outlined"
                                    style={{border:'none',marginTop:'2px'}} 
                                    value={this.state.FrequencyNum} 
                                    disabled={this.state.freqDisableStatus === true? this.state.freqDisableStatus: false}
                                    onChange={this.handleChangeFreq}/>

                               <div style={{fontSize:12,color:"red",border:'none', fontFamily:"'Open Sans', sans-serif", marginTop:"1%"}}>{ this.state.propUpdateFreqdaysErr}</div>
                            </FormControl>
                        </Grid>
                    </Grid>
                </div>
            </div>      
        </DialogContent>
        <DialogActions className="leftp">
            <Button autoFocus onClick={this.handleFreqClose} style={{
                background:'none',
                color:'#3dab35',
                border:" 1px solid rgba(61, 171, 53, 0.5)",
                }} 
                type="submit">{t("cancel")}
            </Button>
            <Button onClick={this.handleFreqSubmit} style={{
                background:'#3dab35',
                color:'white',
                border:" 1px solid rgba(61, 171, 53, 0.5)",
                }}  autoFocus
                type="submit"
                // disabled={this.state.selecedFreq == 'daily'?false: this.state.selecedFreq == 'alternate' ? false: this.state.freqDisableStatus}
                >{t("save")}
            </Button>
        </DialogActions>
    </Dialog>
    </div>









    <div className="">
      <Dialog
        maxWidth={'md'}
        fullWidth={true} 
        // open={true}
        open={this.state.openHistory}
        aria-labelledby="responsive-dialog-title">
        <DialogTitle className="text-center border-none " style={{color:'#3dab35'}}><span style={{fontSize:'18px'}}>{t("scheduledHist")}</span></DialogTitle>
        <DialogContent > 
        <div className="create_ulb_content_outer">
                    <div className="create_ulb_content create_ulb_contentPop">
                    <div className="operator_listing" >
                    <TableContainer component={Paper}>
                             <Table stickyHeader aria-label="sticky table" style={{ tableLayout: 'fixed' }}>
                          
                                <TableHead >
                                    <TableRow >
                                        {headerHistoryPopup}
                                    </TableRow>
                                </TableHead>
                                <TableBody>

                                        {propertyHistory}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
               <div style={{float:"right"}}>
               {/* {
                this.props.totalCountHistory && this.props.totalCountHistory != 0 && 
                    <ReactPaginate
                    previousLabel={"Prev"}
                    nextLabel={"Next"}
                    breakLabel={"..."}
                    breakClassName={"break-me"}
                    pageCount = {10}
                    forcePage = {this.state.activePage}
                    pageCount = {this.props.totalCountHistory/this.state.limit}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    style={{borderLeftWidth:'0px'}}
                    onPageChange={this.handlePageClick}
                    containerClassName={"pagination"}
                    subContainerClassName={"pages pagination"}
                    activeClassName={"active"}/>
                } */}
                
               </div>

                  
                </div>
            </div>      
        </DialogContent>
        <DialogActions className="leftp">
            <Button autoFocus onClick={this.handleClosePopHistory} style={{
                background:'none',
                color:'#3dab35',
                border:" 1px solid rgba(61, 171, 53, 0.5)",
                }} 
                type="submit">{t("cancel")}
            </Button>
           
        </DialogActions>
    </Dialog>
    </div>
    </div>
    )
}
}
const mapStateToProps = state => {
    return {
        totalCount:state.propertyListing.totalCount,
        totalCountHistory : state.propertyListing.loadStatusCount,
        token: state.auth.token,
        headers:state.propertyHeaders.headers,
        propertyListing:!!state.propertyListing.propertyListing&&state.propertyListing.propertyListing,
        zones: state.propertyListing.zones,
        wards : state.propertyListing.wards,
        propertyTypeList: !!state.propertyListing.propertyTypeList? state.propertyListing.propertyTypeList :!!state.propertyListing.ListPropertyTypes ?state.propertyListing.ListPropertyTypes: [] ,
        operatorDay:!!state.operatorDay.operatorDay&&state.operatorDay.operatorDay,
        loadingData: state.propertyListing.loadingSuccess,
        propertyLoadListing: state.propertyListing.propertyListLoad,
        // totalCountLoads: state.propertyListing.totalCountLoads,
        propertyHistory : state.propertyListing.propertySummary,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onFetchPropertyHeaders: (payload) => dispatch(actionsCreators.fetchPropertyHeaders(payload)),
        onFetchPropertyListing: (payload,url,type) => dispatch(actionsCreators.fetchPropertyListing(payload,url,type)),
        onFetchPropertyBulkImport: (payload,formData,props) => dispatch(actionsCreators.fetchPropertyBulkImport(payload,formData,props)),
        onFetchAreaBulkImport: (payload,formData,props) => dispatch(actionsCreators.fetchAreaBulkImport(payload,formData,props)),
        onSchedulePropertyZone :()=> dispatch(actionsCreators.schedulePropertyZone()),
        onSchedulePropertyWard : (payload)=>dispatch(actionsCreators.schedulePropertyWard(payload)),
        onFilterZoneAndWard   : (payload)=> dispatch(actionsCreators.filterZoneAndWard(payload)),
        onSearchProperty:(payload,url,type)=>dispatch(actionsCreators.searchProperty(payload,url,type)),
        onAddFreqSchedule:(payload)=>dispatch(actionsCreators.addFreqSchedule(payload)),
        onPropertyType:()=>dispatch(actionsCreators.propertyType()),
        onAddDayData :(formdata,SubmitProp, props)=>dispatch(actionsCreators.addDayData(formdata,SubmitProp,props)),
        onFetchOperatorDay: (payload,url,type) => dispatch(actionsCreators.fetchOperatorDay(payload,url,type)),
        onDeleteScheduleProperty : (payload)=>dispatch(actionsCreators.deleteSchedule(payload)),
        oNisZoneRequired : (payload, props)=>dispatch(actionsCreators.isZoneRequired(payload, props)),
        onLoadDataSummmary:(payload)=>dispatch(actionsCreators.loadDataSummmary(payload)),
        onfetchPropertyHisorty :(payload)=>dispatch(actionsCreators.fetchPropertyHisorty(payload)),
    }
}

export default  connect(mapStateToProps, mapDispatchToProps) (withTranslation()(ScheduleProperty));